import { useEffect, useMemo } from 'react';

import SectionCard from '@/components/common/SectionCard/SectionCard';
import TagTabs, { TabType } from '@/components/common/TagTabs/TagTabs';
import { useGetReasonTypes } from './hooks/useGetReasonTypes';
import ReasonTypeTab from './components/ReasonTypeTab/ReasonTypeTab';

export default function ReasonCodesContainer() {
  const { isLoading, reasonTypes, getReasonTypes } = useGetReasonTypes();

  const tabs = useMemo<TabType[]>(() => reasonTypes
    .map((el) => ({
      name: el.type,
      title: el.formattedType,
      ContentComponent: () => <ReasonTypeTab reasonType={el} />
    })), [reasonTypes]);

  useEffect(() => {
    getReasonTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SectionCard
        padding={true}
        title={{ titleText: 'Reason Codes' }}
      >
        <div className="row">
          <div className="col-6">
            {tabs.length > 0 && (
              <TagTabs
                tabs={tabs}
                contentClassName="mt-15"
                disabled={isLoading}
                addQueryToUrl={false}
                cacheMode="no-cache"
              />
            )}
          </div>
        </div>
      </SectionCard>
    </>
  );
}
